import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d961ea38"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notifications-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notification_element = _resolveComponent("notification-element")!

  return (!!_ctx.notifications.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification, index) => {
          return (_openBlock(), _createBlock(_component_notification_element, {
            key: `notification-${notification.type}-${index}`,
            notification: notification
          }, null, 8, ["notification"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}